import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { api } from '@/lib/api';
import { Card } from '@/components/ui/card';
import { formatDistanceToNow } from 'date-fns';

export default function AuditPage() {
  const { t } = useTranslation();
  const [items, setItems] = useState([]);

  const load = async () => { const { data } = await api.get('/audit'); setItems(data); };
  useEffect(() => { load(); }, []);

  return (
    <div className="space-y-6" data-testid="audit-page">
      <div>
        <h1 className="font-display text-2xl font-semibold">{t('audit_title')}</h1>
        <p className="text-sm text-[hsl(var(--muted-foreground))] mt-1">{items.length} entries</p>
      </div>
      <Card className="bg-card border border-border">
        <table className="w-full text-sm">
          <thead><tr className="text-left text-[10px] uppercase tracking-wide text-[hsl(var(--muted-foreground))] border-b border-border">
            <th className="px-4 py-3">{t('audit_when')}</th><th className="px-4 py-3">{t('audit_actor')}</th><th className="px-4 py-3">{t('audit_action')}</th><th className="px-4 py-3">{t('audit_resource')}</th><th className="px-4 py-3">Target</th>
          </tr></thead>
          <tbody>
            {items.map((a) => (
              <tr key={a.id} className="border-b border-border/60 hover:bg-accent/40" data-testid={`audit-row-${a.id}`}>
                <td className="px-4 py-3 font-mono text-xs">{a.created_at ? formatDistanceToNow(new Date(a.created_at), { addSuffix: true }) : ''}</td>
                <td className="px-4 py-3">{a.actor_name} <span className="text-[hsl(var(--muted-foreground))] text-xs">({a.actor_email})</span></td>
                <td className="px-4 py-3 font-mono text-xs uppercase">{a.action}</td>
                <td className="px-4 py-3 font-mono text-xs">{a.resource}</td>
                <td className="px-4 py-3 font-mono text-xs text-[hsl(var(--muted-foreground))] truncate max-w-[200px]">{a.target || '—'}</td>
              </tr>
            ))}
            {items.length === 0 && <tr><td colSpan={5} className="px-4 py-8 text-center text-[hsl(var(--muted-foreground))]">{t('no_data')}</td></tr>}
          </tbody>
        </table>
      </Card>
    </div>
  );
}
